(function () {
  'use strict';

  if (window.__rsPerformanceCoreInstalled) return;
  window.__rsPerformanceCoreInstalled = true;

  function optimizeProductBlockLoading() {
    var ProductBlock = window.customElements && window.customElements.get('product-block');
    if (!ProductBlock || ProductBlock.prototype.__rsPerformanceOptimized) return;

    ProductBlock.prototype.__rsPerformanceOptimized = true;

    ProductBlock.prototype.initCustomLazyLoading = function () {
      var self = this;

      function activateHoverImage() {
        var hoverImage = self.querySelector(
          '.product-block__image--show-on-hover.product-block__image--inactivated'
        );

        if (hoverImage) {
          hoverImage.classList.remove('product-block__image--inactivated');
        }

        if (self.__rsHoverImageObserver) {
          self.__rsHoverImageObserver.disconnect();
          self.__rsHoverImageObserver = null;
        }
      }

      if ('IntersectionObserver' in window) {
        this.__rsHoverImageObserver = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            activateHoverImage();
          }
        }, {
          rootMargin: '140px 0px',
          threshold: 0
        });

        this.__rsHoverImageObserver.observe(this);
      } else {
        window.setTimeout(activateHoverImage, 1500);
      }

      this.boundLazyLoadAll = this.lazyLoadAll.bind(this);
      this.addEventListener('mouseenter', this.boundLazyLoadAll, { once: true });
      this.addEventListener('touchstart', this.boundLazyLoadAll, { passive: true, once: true });
    };
  }

  function installLeanCartSync() {
    window.onpageshow = function (event) {
      var navEntries = window.performance && window.performance.getEntriesByType
        ? window.performance.getEntriesByType('navigation')
        : [];
      var navEntry = navEntries && navEntries[0];
      var restoredFromHistory = Boolean(
        (event && event.persisted) ||
        (navEntry && navEntry.type === 'back_forward')
      );

      if (!restoredFromHistory) return;

      function syncCart() {
        fetch(theme.routes.cart + '.js', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP error! Status: ' + response.status);
            return response.json();
          })
          .then(function (data) {
            var cartLink = document.querySelector('.cart-link');
            if (!cartLink || !window.crypto || !window.crypto.subtle || !window.TextEncoder) return;

            var cartString = data.items.map(function (item) {
              return item.key + '|' + item.quantity;
            }).join(',');
            var cartUint8 = new TextEncoder().encode(cartString);

            return window.crypto.subtle.digest('SHA-256', cartUint8).then(function (buffer) {
              var hash = Array.from(new Uint8Array(buffer)).map(function (value) {
                return value.toString(16).padStart(2, '0');
              }).join('');

              if (hash !== cartLink.dataset.hash) {
                document.dispatchEvent(new CustomEvent('on:cart:change', {
                  bubbles: true,
                  cancelable: false
                }));
              }
            });
          })
          .catch(function () {
            // Cart synchronization is a resilience check only.
          });
      }

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(syncCart, { timeout: 900 });
      } else {
        window.setTimeout(syncCart, 180);
      }
    };
  }

  function removeSupplierReferencesFromSizeGuide() {
    var guide = document.getElementById('rs-size-guide');
    if (!guide) return;

    var replacements = [
      ['Printegy-Artikel', 'Artikel'],
      ['Material laut Printegy:', 'Material:'],
      ['Printegy führt ihn in S–XXL;', 'Er ist in S–XXL erhältlich;'],
      ['articles Printegy', 'articles'],
      ['Matière selon Printegy :', 'Matière :'],
      ['Printegy le propose du S au XXL ;', 'Il est disponible du S au XXL ;'],
      ['Printegy-artikelen', 'artikelen'],
      ['Materiaal volgens Printegy:', 'Materiaal:'],
      ['Printegy biedt dit model aan in S–XXL;', 'Het is verkrijgbaar in S–XXL;'],
      ['Printegy items', 'items'],
      ['Material according to Printegy:', 'Material:'],
      ['Printegy offers it in S–XXL;', 'It is available in S–XXL;']
    ];

    guide.querySelectorAll('[data-rs-size-text]').forEach(function (element) {
      var text = element.textContent || '';
      replacements.forEach(function (replacement) {
        text = text.split(replacement[0]).join(replacement[1]);
      });
      element.textContent = text;
    });
  }

  optimizeProductBlockLoading();
  installLeanCartSync();
  removeSupplierReferencesFromSizeGuide();

  document.addEventListener('shopify:section:load', removeSupplierReferencesFromSizeGuide);
})();
